import { useEffect, useRef } from 'react';

/**
 * Subscribes to keydown: Escape → onClose, Enter → onSubmit (if provided).
 * Listener is active only when enabled is true. Cleanup on unmount or when enabled becomes false.
 */
export function useModalKeyboard(options: {
  onClose?: () => void;
  onSubmit?: () => void;
  enabled: boolean;
}) {
  const { onClose, onSubmit, enabled } = options;
  const onCloseRef = useRef(onClose);
  const onSubmitRef = useRef(onSubmit);

  onCloseRef.current = onClose;
  onSubmitRef.current = onSubmit;

  useEffect(() => {
    if (!enabled) return;

    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseRef.current?.();
        event.preventDefault();
        return;
      }
      if (event.key === 'Enter') {
        if (onSubmitRef.current) {
          onSubmitRef.current();
          event.preventDefault();
        }
      }
    };

    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [enabled]);
}
